import { render, staticRenderFns } from "./AreaDetail.vue?vue&type=template&id=45889e7d&scoped=true&"
import script from "./AreaDetail.vue?vue&type=script&lang=js&"
export * from "./AreaDetail.vue?vue&type=script&lang=js&"
import style0 from "./AreaDetail.vue?vue&type=style&index=0&id=45889e7d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45889e7d",
  null
  
)

export default component.exports